import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../components/Modal/CustomModal';
import DivContainerBody from '../../components/DivContainerBody';

const UnlinkDeviceModal = (props) => {
    const { t } = useTranslation();
    const handleUnlink = (e) => {
        props?.onClickFn(e);
        props?.onHide();
    };
    return (
        <CustomModal
            title={t(props.title_modal)}
            size='md'
            buttonConfirm='confirm'
            {...props}
            onHide={() => {
                props.onHide();
                props?.isReset([]);
                props?.isAllReset(false);
            }}
            onConfirm={() => {
                handleUnlink();
            }}
        >
            <DivContainerBody>
                <p className='d-flex justify-content-center align-content-center'>
                    {t(`${props?.description}`)}
                </p>
            </DivContainerBody>
        </CustomModal>
    );
};

export default UnlinkDeviceModal;
